import { render, staticRenderFns } from "./DragHotSpot.vue.js?vue&type=template&id=227f19fa!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DragHotSpot.vue?vue&type=template&id=227f19fa"
import script from "./DragHotSpot.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DragHotSpot.vue?vue&type=script&lang=js"
export * from "./DragHotSpot.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DragHotSpot.vue?vue&type=script&lang=js"
import style0 from "./DragHotSpot.vue.css?vue&type=style&index=0&id=227f19fa&prod&lang=css!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DragHotSpot.vue?vue&type=style&index=0&id=227f19fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports